// extracted by mini-css-extract-plugin
module.exports = {"btn":"EditWeighingButton_btn__2z3QU","custom":"EditWeighingButton_custom__cijX8"};